import classNames from "classnames";
import React, { TextareaHTMLAttributes, useId } from "react";
import "./textarea.scss";

export interface TTextarea extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: string;
    hiddenLabel?: boolean;
    className?: string;
    textareaClassName?: string;
    isValid?: boolean;
    errorMessage?: string;
    disabled?: boolean;
    onDarkBackground?: boolean;
}

export const Textarea = ({
    label,
    hiddenLabel,
    className,
    textareaClassName,
    isValid = true,
    errorMessage,
    disabled,
    onDarkBackground = false,
    ...props
}: TTextarea) => {
    const labelId = useId();
    const finalClassName = classNames("c-textarea", { className });
    const finalLabelClassName = classNames("c-textarea__label", {
        "c-textarea__label--hidden": hiddenLabel,
        "c-textarea__label--on-dark-bg": onDarkBackground,
    });
    const finalTextareaClassName = classNames(
        "c-textarea__textarea",
        { textareaClassName },
        { "c-textarea--error": !isValid },
        { "c-textarea--disabled": disabled }
    );

    return (
        <div className={finalClassName}>
            <label id={labelId} className={finalLabelClassName}>
                {label}
            </label>
            <textarea
                className={finalTextareaClassName}
                aria-labelledby={label ? labelId : undefined}
                disabled={disabled}
                {...props}
            />
            {!isValid && errorMessage && <p className="c-textarea--error-message">{errorMessage}</p>}
        </div>
    );
};
